import {
  SurgicalHistory,
  SurgicalHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

type Params = {
  surgicalHistory: SurgicalHistory;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePastSurgicalHistoryCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new SurgicalHistoryControllerApi(
      getConfigObject()
    ).createPatientSurgicalHistory(params.surgicalHistory, params.xTENANTID)
  );
